import { ReactNode } from 'react';
import useCountryContext, {
  CountryContext,
} from '../../core/hooks/useCountryContext';

interface RequireRoCountryProps {
  children: ReactNode;
  requiredCountry: CountryContext;
}

const RequireCountry = ({
  children,
  requiredCountry,
}: RequireRoCountryProps) => {
  const { countryContext } = useCountryContext();

  if (countryContext !== requiredCountry) {
    return (
      <div className="flex h-full w-full items-center justify-center p-4 text-center">
        <p className="text-lg font-semibold dark:text-white">
          OOH monitoring is not enabled for this country
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default RequireCountry;
